import { render, staticRenderFns } from "./ListeningTaskConfig.vue?vue&type=template&id=dd083e40"
import script from "./ListeningTaskConfig.vue?vue&type=script&lang=js"
export * from "./ListeningTaskConfig.vue?vue&type=script&lang=js"
import style0 from "./ListeningTaskConfig.vue?vue&type=style&index=0&id=dd083e40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports